export default "__VITE_ASSET__cY78RnEB__"